import { Box, FlexBox, Text } from '@trmediaab/zebra';

import Img from '~/components/Img';
import { ThemedLink } from '~/components/ThemedLink';

import Breadcrumb from './Breadcrumb';
import { buildArticleLink, getBetTypeColor, getMetaLabels } from './utils';

export default function NewsTeaser({ data, showImage, round }) {
  return (
    <Box>
      <ThemedLink
        to={buildArticleLink(data)}
        sx={{
          "&:hover [data-id='headline'] ": {
            textDecoration: 'underline',
          },
        }}
      >
        <FlexBox flexDirection="column">
          {showImage && (
            <Img
              width={980}
              aspectRatio={[16, 9]}
              image={data.teaser_image || data.image}
            />
          )}

          <FlexBox
            bg="white"
            flexDirection="column"
            flex={1}
            minHeight={120}
            px={{ _: 3, md: '3,5' }}
            py={{ _: 3, md: '3,5' }}
            gap="1"
          >
            <Breadcrumb
              type={data.type}
              meta={getMetaLabels(data.round)}
              color={getBetTypeColor(data, round)}
            />

            <Text
              fontSize={{ _: 3, md: 5 }}
              fontWeight="bold"
              color="black"
              textDecoration="inherit"
              data-id="headline"
            >
              {data.teaser_headline || data.headline}
            </Text>

            <Text fontSize={{ _: 1, md: 2 }} color="greys.6">
              {data.teaser || data.preamble}
            </Text>
          </FlexBox>
        </FlexBox>
      </ThemedLink>
    </Box>
  );
}
